module.exports = __webpack_public_path__ + "img/vip-move.3e4b74e5.png";